export default "__VITE_ASSET__mPGPGeqm__"